module.exports = __webpack_public_path__ + "img/line_mobile_fo50e3.8dc835d0.svg";